<div class="sidebar-container">
  <div class="search-box">
    <input
      type="text"
      [placeholder]="translateService.getTranslation(4154)"
      [ngModel]="state.searchTerm()"
      (ngModelChange)="onSearch($event)"
    />
    <span class="material-symbols-outlined search-icon">search</span>
  </div>

  <div class="section-label">{{ translateService.getTranslation(4137) }}</div>

  <div class="chat-list">
    @for (chat of state.filteredChatList(); track chat.id) {
      <div
        class="chat-item"
        [class.active]="state.selectedChatId() === chat.id"
        (click)="selectChat(chat)"
      >
        <div class="avatar-wrapper">
          @if (chat.type === 'GROUP') {
            <div class="avatar group-avatar">
              <span class="material-symbols-outlined">group</span>
            </div>
          } @else {
            <app-profile-pic
              class="avatar"
              [name]="chat.otherUserName ?? chat.name"
            />
          }
          @if (chat.isOnline) {
            <span class="online-dot"></span>
          }
        </div>

        <div class="chat-info">
          <span class="chat-name">
            {{ chat.type === 'PRIVATE' ? chat.otherUserName : chat.name }}
          </span>
          <span class="chat-preview">
            {{ truncateMessage(chat.lastMessage?.content) }}
          </span>
        </div>

        @if (chat.unreadCount > 0) {
          <span class="unread-badge">{{ chat.unreadCount }}</span>
        }
      </div>
    } @empty {
      @if (state.filteredUserResults().length === 0) {
        <div class="empty-list">{{ translateService.getTranslation(4139) }}</div>
      }
    }

    @if (state.filteredUserResults().length > 0) {
      <div class="section-label contacts-label">{{ translateService.getTranslation(4138) }}</div>
      @for (user of state.filteredUserResults(); track user.userId) {
        <div
          class="chat-item"
          (click)="selectUser(user)"
        >
          <div class="avatar-wrapper">
            <app-profile-pic [name]="user.userName" />
            @if (state.onlineUserIds().has(user.userId)) {
              <span class="online-dot"></span>
            }
          </div>
          <div class="chat-info">
            <span class="chat-name">{{ user.userName }}</span>
          </div>
        </div>
      }
    }
  </div>

  <button
    class="create-group-btn"
    (click)="openCreateGroup()"
  >
    <span class="material-symbols-outlined">group_add</span>
  </button>
</div>
